import { combineReducers } from '@reduxjs/toolkit';
import { createMigrate, createTransform, persistReducer } from 'redux-persist';
import { MigrationManifest } from 'redux-persist/es/types';
import storage from 'redux-persist/lib/storage';

import { rtkQuery } from '~/services/rtkQuery';

import packageJson from '../../package.json';
import { resetStore } from './slices/app';
import { generatedLinkReducer } from './slices/generatedLink';
import { notificationReducer } from './slices/notification';
import { userReducer } from './slices/user';

const transforms = [
  createTransform(
    state => JSON.stringify(state),
    state =>
      JSON.parse(state, (key, value) =>
        typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)
          ? new Date(value)
          : value,
      ),
  ),
];

const migrations: MigrationManifest = {
  /* eslint-disable no-underscore-dangle */
  0: state => (state ? { _persist: state._persist } : state),
};

const rootPersistConfig = {
  key: packageJson.name,
  storage,
  whitelist: ['user'],
  transforms,
  version: 0,
  migrate: createMigrate(migrations),
};

const appReducer = combineReducers({
  user: userReducer,
  notification: notificationReducer,
  generatedLink: generatedLinkReducer,
  [rtkQuery.reducerPath]: rtkQuery.reducer,
});

const reducer: typeof appReducer = (state, action) => {
  if (action.type === resetStore.toString()) {
    state = undefined;
  }
  return appReducer(state, action);
};

export const rootReducer = persistReducer<ReturnType<typeof reducer>>(rootPersistConfig, reducer);
